<script setup lang="ts">
    import { useI18n } from 'vue-i18n';
    import type { User } from '@/types';
    import EmployeeAvatar from '../EmployeeAvatar.vue';

    const { t } = useI18n();

    const props = defineProps<{
        employee: User;
    }>();
</script>

<template>
    <div class="flex shrink-0 items-center gap-2.5">
        <EmployeeAvatar
            :user="employee"
            class="size-16 border-none"
        />
        <div class="flex flex-col gap-1">
            <!-- <div class="text-primary text-xs">
                Job titel |
                <span class="font-bold">Afdeling</span>
            </div> -->
            <div class="text-xs font-bold">{{ employee.name }}</div>
            <a
                :href="`mailto:${employee.email}`"
                class="text-xs hover:underline"
            >
                {{ employee.email }}
            </a>
            <a
                :href="`tel:${employee.phone}`"
                class="text-xs hover:underline"
            >
                {{ employee.phone }}
            </a>
        </div>
    </div>
</template>
